<template>
  <div class="login-container">
    <div class="login-wrapper">
      <zm-row>
        <zm-col :span="12">
          <div class="login-left-container">
            <img class="logo" src="../../assets/ZoomLogo.png">
            <p class="title">AsyncMQ</p>
          </div>
        </zm-col>
        <zm-col :span="12" style="background-color: #ffffff;">
      <zm-form class="login-form" autoComplete="on" :model="loginForm" :rules="rules" ref="loginForm" label-position="left">
        <zm-form-item prop="username" label="Username">
          <zm-input size="small" name="username" type="text" v-model="loginForm.username" autoComplete="on" placeholder="username" />
        </zm-form-item>
        <zm-form-item prop="password" label="Password">
          <zm-input size="small" name="password" type="password" @keyup.enter.native="handleLogin" v-model="loginForm.password" autoComplete="on"
            placeholder="password"></zm-input>
        </zm-form-item>
        <zm-form-item>
          <zm-button size="small" type="primary" style="width:100%;" @click.native.prevent="handleLogin" :loading="loading">
            Sign in
          </zm-button>
        </zm-form-item>
      </zm-form>
        </zm-col>
      </zm-row>
    </div>
  </div>
</template>

<script>
import { login, getToken } from '../../api/index'
import { listTooltip } from '../../api/tip'
export default {
  name: 'login',
  data () {
    return {
      loading: false,
      loginForm: {
        username: '',
        password: ''
      },
      rules: {
          username: [
              { required: true, message: 'please enter username', trigger: 'blur' }
          ],
          password: [
              { required: true, message: 'please enter password', trigger: 'blur' }
          ]
      }
    }
  },
  watch: {
    $route () {
      if (this.$route.query.token) {
        var token = this.$route.query.token
        this.login(token)
      }
    }
  },
  created () {
    if (this.$route.query.token) {
      var token = this.$route.query.token
      this.login(token)
    }
  },
  methods: {
    listTooltip () {
      listTooltip().then(response => {
        localStorage.tips = JSON.stringify(response)
      }).catch(() => {
        localStorage.tips = {}
      })
    },
    login (token) {
      this.loading = true
      getToken(token).then(response => {
        this.loading = false
        localStorage.setItem('username', response.name)
        localStorage.setItem('token', response.token)
        localStorage.setItem('refreshToken', response.refreshToken)
        localStorage.setItem('role', response.role)
        if (response.token) {
          this.listTooltip()
          const path = localStorage.path
          // const params = localStorage.params
          if (path) {
            this.$router.push({
                path
            })
          } else {
          this.$router.push('/')
        }
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handleLogin () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          login(this.loginForm).then(response => {
            this.loading = false
            if (this.loginForm.username !== localStorage.username) {
              localStorage.path = ''
            }
            localStorage.setItem('username', this.loginForm.username)
            localStorage.setItem('token', response.token)
            localStorage.setItem('refreshToken', response.refreshToken)
            localStorage.setItem('role', response.role)
            this.listTooltip()
          const path = localStorage.path
          // const params = localStorage.params
          if (path) {
            this.$router.push({
                path
            })
          } else {
            this.$router.push('/')
          }
          }).catch(() => {
            this.loading = false
            // if (err.response.data.status === 401) {
            //   this.$message({
            //     type: 'error',
            //     message: 'Invalid username or passsword!'
            //   })
            // }
          })
      }
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.title {
  font-size: 32px;
}
$bg:#fff;
.login-container {
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: $bg;
  text-align: center;
  color: #67747a;
  .login-wrapper {
    position: absolute;
    left: 0;
    right: 0;
    max-width: 1020px;
    background-color: #dae0e9;
    margin: calc((100vh - 500px) / 2) auto;
    border-radius: 12px;
    box-shadow: 0 4px 40px 0 #ededed;
    .login-left-container {
      margin: calc((100% - 200px) / 2) auto;
      padding: 20px 0 0 20px;
      color: #595959;
      border-radius: 0 12px 12px 0;
    }
    .login-form {
      margin: calc((100% - 300px) / 2) auto;
      padding: 30px;
      background-color: #ffffff;
    }
  }
}
</style>
